<template>
    <div class="login-wrap">
        <div class="login-box">
            <div class="login-input">
                <label>
                    <span>Your Nick</span>
                    <input type="text" id="unick" class="input-nick" maxlength="20" placeholder="Please input your Nick!" v-model="comp.nick">
                </label>
            </div>
            <button class="btn btn-login" @click="comp.doLogin">Login</button>
        </div>
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
// import axios from "axios";
import { useToast } from 'vue-toastification';
// import { useRouter } from 'vue-router';
import { useStore } from 'vuex'

export default {
    name: "Login",
    components: {
    },
    setup() {
        const toast  = useToast();
        // const router = useRouter();
        const store = useStore()

        const comp = reactive({
            nick : '',

            doLogin: () => {
                let user = {
                    idx:1, uid:comp.nick, ename:comp.nick
                }

                if( !user.uid ) {
                    toast.warning("Please input your nick!");
                    document.getElementById("unick").focus()
                    return
                }

                if( user.uid.split(' ').length > 1 ){
                    toast.warning("Please enter without spaces.");
                    document.getElementById("unick").focus()
                    return
                }

                store.commit('setUser', user)

                toast.success("Hello, " + user.ename + ".", ()=>{
                    // router.push({ path:'/Front/List', params:{} })
                    location.href = '/Front/List'
                })
                setTimeout(() => {
                    // router.push({ path:'/Front/List', params:{} })
                    location.href = '/Front/List'
                }, 1000)
            },


        });

        onMounted(() => {
            // Mounted
        });

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .login-wrap {
        position:fixed; top:0; left:0; right:0; bottom:0; width:100%; height:100%;
        .login-box {
            position:absolute; top:0; left:0; right:0; bottom:0; width:calc(100% - 20px); max-width:400px; height:100%; max-height:300px; margin:auto;
            background-color:#fff; padding:10px; border:1px solid #dfdfdf;
            .login-input {
                margin-top:20px;
                font-size:1.3em;
                span {
                    display:block;
                    padding:10px; color:#fe6434; font-weight:bold; text-align: left;
                }
                input {
                    font-size:1.3em;border:1px solid #fe825c; border-radius:0;outline:none; padding:10px; width:100%;
                }
            }
            button {
                width:100%; margin-top:10px;
                font-size:1.3em; border:1px solid #fe6434; border-radius:0;
                padding:10px; background-color:#fe825c; color:#fff1ec;
            }
        }
    }

</style>
